import React from 'react';

/**
 * Rich-text renderers for the auth copy. Hoisted, so they are not new components on every render.
 * formatMessage returns an array when a message has tags, so each element has a key.
 */
export const renderGradient = (chunks: React.ReactNode): React.ReactNode => (
  <span key="grad" className="grad-tx">
    {chunks}
  </span>
);

export const renderBold = (chunks: React.ReactNode): React.ReactNode => <b key="b">{chunks}</b>;
